export default {"src":"/_next/static/media/visibility.3b748252.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};